import { Link, } from 'react-router-dom';
import { Alert, Box, Stack, Typography, Grid, Button, } from '@mui/material';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks3Icon from '@mui/icons-material/Looks3';
import Looks4Icon from '@mui/icons-material/Looks4';

const advantages = [
    {
        text: 'Всё просто. Создавайте сеты карточек',
        Icon: LooksOneIcon,
    },
    {
        text: 'Группируйте сеты по папкам для удобной работы',
        Icon: LooksTwoIcon,
    },
    {
        text: 'Два режима обучения: «Карточки» и «Орфография»',
        Icon: Looks3Icon,
    },
    {
        text: 'Возможность изучения избранных карточек с выбором языка ответа',
        Icon: Looks4Icon,
    },
];

const styles = {
    authButtonStyles: {
        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
        boxShadow: 2,
        color: 'common.white',
        py: 1,
        px: 2,
        '&:hover': {
            bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'common.kashmirBlue',
        },
    },
};

const LandingPage = () => {
    return (
        <Grid container sx={{ boxShadow: 5, mt: [3, 4, 5, 6], }}>
            <Grid item xs={12} md={6} sx={{ bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.shark' : 'grey.200', p: [5, 6, 7, 8], }}>
                <Typography sx={{ color: 'text.primary', fontSize: [34, 44, 54, 64], fontWeight: 700, lineHeight: 1.15, letterSpacing: 2.5, mb: 1.5, overflowWrap: 'anywhere', }}>
                    Учитесь вместе с <Box component='span' sx={{ color: 'secondary.main' }}>Cards</Box>
                </Typography>
                <Typography
                    sx={{
                        color: 'text.secondary',
                        fontSize: 13,
                        mb: 5,
                    }}>Учебная платформа специально разработанная для тех, кто хочет получить максимальную эффективность от обучения в короткие сроки</Typography>
                <Stack direction="row" spacing={1.5} sx={{ mb: 5, }}>
                    <Button
                        component={Link}
                        to='/login'
                        sx={{
                            ...styles.authButtonStyles,
                        }}
                    >Войти</Button>
                    <Button
                        component={Link}
                        to='/signup'
                        sx={{
                            ...styles.authButtonStyles,
                        }}
                    >Регистрация</Button>
                </Stack>
                <Alert variant="outlined" severity="info" sx={{ color: 'text.primary', fontWeight: 'bold', wordBreak: 'normal', }}>Тестовый аккаунт (логин: test@mail.ru, пароль: 12345678)</Alert>
            </Grid>
            <Grid item xs={12} md={6} sx={{ bgcolor: (theme) => theme.palette.mode === 'dark' ? 'common.rhino' : 'grey.50', p: [5, 6, 7, 8], }}>
                <Stack
                    direction='column'
                    justifyContent='center'
                    sx={{
                        height: '100%',
                    }}>
                    <Box
                        component='ul'
                        sx={{
                            listStyle: 'none',
                            m: 0,
                            p: 0,
                            '& > * + *': {
                                mt: 3,
                            },
                        }}>
                        {
                            advantages.map(({ text, Icon }) => {
                                return (
                                    <Stack key={text} direction='row' component='li'>
                                        <Icon sx={{
                                            color: 'text.primary',
                                            fontSize: [21, 23, 25, 27],
                                            mr: [1.4, 1.5, 1.6, 1.7],
                                        }} />
                                        <Typography sx={{
                                            color: 'text.primary',
                                            fontSize: [15, 16, 17, 18],
                                        }
                                        }>{text}</Typography>
                                    </Stack>
                                )
                            })
                        }
                    </Box>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default LandingPage;